import * as React from "react";
import { useTypewriter } from "@/hooks/use-typewriter";
import { Loader } from "@/components/ui/loader";
import { useGetNarrativeChronologyQuery } from "@/api/chronology";
import { MarkdownRenderer } from "@/components/feature/markdown/markdownRenderer";
import type { DocumentChronology } from "@/types/chronology";
import { RightSidebarNarrativeCopy } from "@/views/chronology/components/rightSidebar/rightSidebarNarrativeCopy";

interface Props {
  documentChronology: DocumentChronology;
}

export const RightSidebarNarrative: React.FC<Props> = ({ documentChronology }) => {
  const { data: narrative = "", isFetching } = useGetNarrativeChronologyQuery(documentChronology.fse_id);

  const typedNarrative = useTypewriter(narrative, 10);

  return (
    <div className="p-5">
      {!isFetching && !!narrative && <RightSidebarNarrativeCopy narrative={narrative} />}
      {isFetching ? <Loader /> : <MarkdownRenderer content={typedNarrative} evidences={[]} processCitations={false} />}
    </div>
  );
};
